import type { MerryMarkdownDocument } from "./markdownSchema";

const maxEntries = 200;
const maxSourceBytes = 2 * 1024 * 1024;

interface CacheEntry {
  document: MerryMarkdownDocument;
  sourceBytes: number;
}

const cache = new Map<string, CacheEntry>();
let cachedSourceBytes = 0;

export function getCachedMarkdownDocument(key: string) {
  const entry = cache.get(key);
  if (!entry) return null;
  cache.delete(key);
  cache.set(key, entry);
  return entry.document;
}

export function setCachedMarkdownDocument(
  key: string,
  document: MerryMarkdownDocument,
  sourceBytes: number,
) {
  if (sourceBytes > maxSourceBytes) return;
  const current = cache.get(key);
  if (current) {
    cachedSourceBytes -= current.sourceBytes;
    cache.delete(key);
  }
  cache.set(key, { document, sourceBytes });
  cachedSourceBytes += sourceBytes;
  while (cache.size > maxEntries || cachedSourceBytes > maxSourceBytes) {
    const oldest = cache.entries().next().value as
      | [string, CacheEntry]
      | undefined;
    if (!oldest) break;
    cache.delete(oldest[0]);
    cachedSourceBytes -= oldest[1].sourceBytes;
  }
}

export function clearMarkdownDocumentCacheForTests() {
  cache.clear();
  cachedSourceBytes = 0;
}
